const PaymentStatus = {
    OK: "OK",
    ERROR: "ERROR",
    WAIT: "WAIT",
    FINISH: "FINISH",
    CANCELED: "CANCELED",
    REFUND: "REFUND",
    ERROR_ON_FINISH: "ERROR_ON_FINISH",
};

PaymentStatus.contains = (str) => {
    return Object.values(PaymentStatus).includes(str);
};

PaymentStatus.isReturned = (str) => {
    return str === PaymentStatus.REFUND || str === PaymentStatus.CANCELED;
}

Object.freeze(PaymentStatus);

module.exports = PaymentStatus;